










import {Component, Vue} from 'vue-property-decorator';
import {currentUserModule} from "@/store";
import AuditTrailTable from "../../components/admin/AuditTrailTable.vue";

@Component({
    components: {AuditTrailTable}
})
export default class AuditTrail extends Vue {
    get canSeeAuditTrail() {
        return currentUserModule.hasRight("UserGetAllCmd");
    }
}
